"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchConfig = exports.config = void 0;
const DEFAULT_CONFIG_PATH = "/config.json";
const defaultConfig = { isReady: false };
const config = { ...defaultConfig };
const fetchConfig = async (path = DEFAULT_CONFIG_PATH) => {
    const response = await fetch(path);
    if (response.ok) {
        const fetchedConfig = await response.json();
        Object.assign(config, { ...fetchedConfig, isReady: true });
    }
    return config;
};
exports.fetchConfig = fetchConfig;
const configProxy = new Proxy(config, {
    get(target, prop) {
        if (prop !== "isReady" && !target.isReady) {
            throw new Error("Config has not been fetched yet. Please call `fetchConfig` and ensure it completes successfully before accessing config properties.");
        }
        return target[prop];
    },
});
exports.config = configProxy;
//# sourceMappingURL=config-repo.js.map